import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue'
import { cluerApplyecord } from '@/api/overseasSales/clueManage'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'TabsOperationLog'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  returnName: {
    type: String
  },
  title: String
},
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const props = __props
const state = computed(() => {
  return {
    1: t('operate.sukg7w'),
    2: t('operate.cfq4cr'),
    3: t('operate.fvmvfe')
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.recordId) {
    cluerApplyecord({
      recordId: route.query.recordId
    }).then((res) => {
      // 处理数据
      const result = []
      result.push({
        checkTime: res.data.applyTime,
        checkUser: res.data.createByName,
        applyReason: res.data.applyReason,
        checkNode: '申请',
        ...res.data
      })
      // 审批
      result.push({
        checkTime: res.data.auditTime,
        checkUser: res.data.auditorName,
        checkNode: '审批',
        ...res.data
      })
      // 拼申请人
      callBack({
        data: result
      })
    })
  }
}
const columns = computed(() => [
  {
    title: t('common.operatorDate'),
    dataIndex: 'checkTime'
  },
  {
    title: t('common.operator'),
    dataIndex: 'checkUser'
  },
  {
    title: t('clue.panelPoint '),
    dataIndex: 'checkNode'
  },
  {
    title: t('clue.approvalContent'),
    dataIndex: 'content'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { scrollToFirstError: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 24
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_cos_table, {
                tableId: "DcCosOFbuApplyRecord",
                needPage: false,
                serial: "",
                columns: columns.value,
                onFetch: fetch,
                ref: "table"
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'checkNode')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (record.checkNode === '申请')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('clue.approvalPersonNode')), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('clue.approvalNode')), 1))
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'content')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (record.checkNode === '申请')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(`${_unref(t)('clue.approvalCause')}${record.applyReason}`), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(state.value[record.auditStatus]) + " " + _toDisplayString(record.opinion ? `【${record.opinion}】` : ''), 1))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})